document.addEventListener('alpine:init', () => {
  Alpine.data('FAQ', () => ({
    search_q: '',
    faq_items: [],
    trending_items: [],
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      let faq_items = JSON.parse(am.$el.dataset.blocks);
      let ids = JSON.parse(am.$el.dataset.blocksIds);
      faq_items.forEach((item, index) => {
        item.id = ids[index];
      });
      am.faq_items = [...faq_items];

      am.trending_items = [...faq_items.filter(item => item.trending)];
    },
    ShowFaq(block_id) {
      let am = this;
      if (!am.search_q) return true;
      let search_q = am.search_q.toLowerCase();

      let faq_item = am.faq_items.find(item => item.id == block_id);
      // console.log(am.faq_items, block_id)
      return faq_item.title.toLowerCase().indexOf(search_q) !== -1;
      // return faq_item.title.toLowerCase().indexOf(search_q) !== -1 || 
      //   faq_item.answer.toLowerCase().indexOf(search_q) !== -1;
    }
  }));
});